<script setup lang="ts">
import { computed } from 'vue'
import { useScrollAnimation } from '../composables/useScrollAnimation'

const props = withDefaults(defineProps<{
  as?: string
  delay?: number
  duration?: number
}>(), {
  as: 'div',
  delay: 0,
  duration: 0.6,
})

const { elRef, isVisible } = useScrollAnimation()

const style = computed(() => ({
  transitionDelay: `${props.delay}s`,
  transitionDuration: `${props.duration}s`,
}))
</script>

<template>
  <component
    :is="props.as"
    ref="elRef"
    class="scroll-animate"
    :class="{ 'scroll-animate-visible': isVisible }"
    :style="style"
  >
    <slot />
  </component>
</template>
